import type { SVGProps } from "react";

// Letter-mark fallbacks: sparkle has no Amazon/Qwen/NVIDIA/AWS-Bedrock marks.
function letterLogo(letter: string) {
  return function LetterLogo(props: SVGProps<SVGSVGElement>) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        aria-hidden
        {...props}
      >
        <text
          x="12"
          y="17.5"
          textAnchor="middle"
          fontSize="17"
          fontWeight="700"
          fill="currentColor"
          fontFamily="system-ui, sans-serif"
        >
          {letter}
        </text>
      </svg>
    );
  };
}

export const BedrockLogo = letterLogo("B");
export const AmazonLogo = letterLogo("a");
export const QwenLogo = letterLogo("Q");
export const NvidiaLogo = letterLogo("N");
